/**
 * Режимы игры на клиенте: список приходит с сервера (ServerInfo.variants), тексты карточек —
 * из словаря по id режима (lobby.variant.<id>.*). Неизвестный клиенту режим показывается
 * с названием сервера и без описания — новый режим можно добавить на сервере раньше перевода.
 */
import type { GameStage, GameVariantInfo, ServerInfo } from '@mt/protocol';
import { hasKey, t, type TKey, type TParams } from '../i18n';
import { STAGE_TITLES } from './format';

/** Режим стола (категории) по её id; null — стол неизвестен. */
export function variantOfCategory(info: ServerInfo | null, categoryId: string): GameVariantInfo | null {
  const cat = info?.categories.find((c) => c.id === categoryId);
  return info?.variants.find((v) => v.id === cat?.variantId) ?? null;
}

/** Инструмент и цена известны с начала розыгрыша («Открытые карты»). */
export const isOpenVariant = (v: Pick<GameVariantInfo, 'instrument'> | null | undefined): boolean => !!v?.instrument;

/** Текст карточки режима: field — title, tag, text, badge, f1, f2, demoNote; null — перевода нет. */
export function variantText(v: GameVariantInfo, field: string, params?: TParams): string | null {
  const key = `lobby.variant.${v.id}.${field}` as TKey;
  return hasKey(key) ? t(key, params) : null;
}

export const variantTitle = (v: GameVariantInfo): string => variantText(v, 'title') ?? v.title;

/** Название этапа с учётом режима: в «Открытых картах» круги называются по тому, что в них решается. */
export function stageTitle(stage: GameStage, open: boolean): string {
  if (open && (stage === 'round1' || stage === 'round2' || stage === 'round3')) return t(`common.stageOpen.${stage}`);
  return STAGE_TITLES[stage];
}
